import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { useLanguage } from './LanguageContext';

export const FAQ = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 bg-[#FFFDF8]"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Left header */}
          <div className="lg:col-span-5">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="font-display font-extrabold tracking-tight text-stone-900 text-4xl md:text-5xl"
            >
              {t.faq.title}
            </motion.h2>
            <p className="mt-4 text-stone-600 text-base md:text-lg">{t.faq.subtitle}</p>
            <div className="mt-8 inline-block font-accent text-2xl text-orange-600 -rotate-2">
              ↓
            </div>
          </div>

          {/* Items */}
          <div className="lg:col-span-7 divide-y divide-stone-200">
            {t.faq.items.map((item, i) => {
              const isOpen = open === i;
              return (
                <button
                  key={i}
                  type="button"
                  data-testid={`faq-item-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full text-left py-6 group"
                  aria-expanded={isOpen}
                >
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="font-display font-bold text-stone-900 text-lg md:text-xl pr-4 group-hover:text-orange-600 transition-colors">
                      {item.q}
                    </h3>
                    <span
                      className={`flex-shrink-0 mt-0.5 h-9 w-9 rounded-full flex items-center justify-center transition-all ${
                        isOpen ? 'bg-orange-500 text-white rotate-180' : 'bg-stone-100 text-stone-700'
                      }`}
                    >
                      {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                    </span>
                  </div>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pt-4 pr-12 text-stone-600 leading-relaxed">{item.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
